import { CircleHelp } from "lucide-react";
import { FC } from "react";

import { Card, CardContent, CardHeader } from "@/components/ui/card";

import { AddContentButton } from "./add-content-button";
import { GalleryItems } from "./gallery-items";
import { useGalleryTabContext } from "./gallery-tab-context";

export const GalleryTabContent: FC = () => {
  const { data } = useGalleryTabContext();

  return (
    <Card>
      <CardHeader>
        <h4 className="text-lg font-medium leading-none">Content</h4>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <GalleryItems items={data} />

          <div className="flex items-center gap-2">
            <CircleHelp className="size-6 text-muted-foreground" />
            <p className="text-sm font-medium text-muted-foreground">
              View our documentation on optimizing your galleries.
            </p>
          </div>

          <AddContentButton />
        </div>
      </CardContent>
    </Card>
  );
};
